<!--
   Created by qing on 2020/2/19 1:39 下午
   Des:
-->
<template>
  <div>
    <div>
      <div
        v-if="filter.method === FILTER_METHOD_TYPE__EQ"
        class="filter-content"
        @click="selectDateFixedValue.onClickDateFixedValue(filter)">
        <van-tag
          class="filter-tag"
          plain
          type="warning"
          size="large">
          {{ timeOpt.filter(time => time.value === filter.fixedValue)[0].name }}
        </van-tag>
      </div>

      <div
        v-if="filter.method !== FILTER_METHOD_TYPE__RANGE && filter.fixedValue === 'fixed_value'"
        class="filter-content"
        @click="selectDateConfig.onClickSelectDate(filter)">
        {{actionFormatTime(filter.value[0])}}
      </div>
      <template v-if="filter.method === FILTER_METHOD_TYPE__RANGE">
        <div
          class="filter-content"
          @click="selectDateConfig.onClickSelectDate(filter, 'start')">
          开始时间 <span style="float: right;">{{actionFormatTime(filter.value[0])}}</span>
        </div>
        <div
          class="filter-content"
          @click="selectDateConfig.onClickSelectDate(filter, 'end')">
          结束时间 <span style="float: right;">{{actionFormatTime(filter.value[1])}}</span>
        </div>
      </template>
    </div>


    <!--选择时间类型（fixedValue）-->
    <van-action-sheet
      v-model="selectDateFixedValue.visible"
      :actions="timeOpt"
      @select="selectDateFixedValue.onSelect"
      cancel-text="取消"
      get-container="body"
      close-on-click-action/>

    <!--选择时间-->
    <van-popup
      position="bottom"
      :style="{ height: '40%' }"
      get-container="body"
      v-model="selectDateConfig.visible">
      <van-datetime-picker
        v-model="selectDateConfig.selectTime"
        type="datetime"
        :min-date="selectDateConfig.minDate"
        :max-date="selectDateConfig.maxDate"
        @confirm="selectDateConfig.onConfirm"
        @cancel="selectDateConfig.visible = false">
      </van-datetime-picker>
    </van-popup>
  </div>
</template>

<script>
  import current from "./mixin"
  import {formatDate} from "../../../../assets/js/Untis"
  import {FILTER_METHOD_TYPE__RANGE} from "../types";
  export default {
    mixins: [current],
    data() {
      return {

        timeOpt: [
          {
            value: "fixed_value",
            name: "固定值"
          },
          {
            value: "today",
            name: "今天"
          },
          {
            value: "yesterday",
            name: "昨天"
          },
          {
            value: "this_week",
            name: "本周"
          },
          {
            value: "last_week",
            name: "上周"
          },
          {
            value: "this_month",
            name: "本月"
          },
          {
            value: "last_month",
            name: "上月"
          },
          {
            value: "this_year",
            name: "本年"
          },
          {
            value: "last_year",
            name: "上年"
          },
        ],

        // 选择时间fixedValue
        selectDateFixedValue: {
          visible: false,
          dateFilter: null,

          // 选择时间控件的fixedValue
          onClickDateFixedValue: (item) => {
            this.selectDateFixedValue.dateFilter = item
            this.selectDateFixedValue.visible = true
          },
          onSelect: (item) => {
            this.selectDateFixedValue.dateFilter.fixedValue = item.value
            this.selectDateFixedValue.visible = false
          }
        },

        // 选择时间数据
        selectDateConfig: {
          visible: false,
          filterCondition: null, // 一个筛选条件对象
          rangType: '',
          selectTime: new Date().getTime(),
          minDate: new Date('1970'),
          maxDate: new Date('2120'),

          // 选择时间
          onClickSelectDate: (item, rangType) => {
            this.selectDateConfig.rangType = rangType
            this.selectDateConfig.filterCondition = item
            if (item.method === FILTER_METHOD_TYPE__RANGE) {
              if (rangType === 'start') {
                this.selectDateConfig.selectTime = item.value[0] ? new Date(item.value[0]) : new Date()
              } else if (rangType === 'end') {
                this.selectDateConfig.selectTime = item.value[1] ? new Date(item.value[1]) : new Date()
              }
            } else {
              this.selectDateConfig.selectTime = item.value[0] ? new Date(item.value[0]) : new Date()
            }
            this.selectDateConfig.visible = true
          },

          onConfirm: (date) => {
            console.log(date)
            this.selectDateConfig.visible = false
            const condition = this.selectDateConfig.filterCondition
            if (condition.method === FILTER_METHOD_TYPE__RANGE) {
              if (this.selectDateConfig.rangType === 'start') {
                condition.value.splice(0, 1, +date)
              } else if (this.selectDateConfig.rangType === 'end') {
                condition.value.splice(1, 1, +date)
              }
            } else {
              condition.value.splice(0, condition.length, +date)
            }
          }
        }
      };
    },
    methods: {
      fixedValueChange() {
        this.current.splice(0, this.current.length)
      },

      actionFormatTime(d) {
        if (!d || d <= 0) {
          return ''
        }
        return formatDate(d)('yyyy-MM-dd HH:mm')
      },
    }
  };
</script>

<style lang="less">

  .filter-date-container {

    .el-select {
      width: 100px;
      margin-right: 10px;
    }
  }
</style>
